<template>
  <div>
    <v-dialog
      v-model="open"
      width="fit-content"
      persistent
      content-class="shopee-pay-container"
      @after-leave="resetShopeePay"
    >
      <v-card class="modal-body-container">
        <div class="modal-header">
          <img
            src="@/assets/shopeepay-logo-horizontal-white.png"
            alt="ShopeePay"
            width="96"
          />
        </div>

        <div class="modal-body">
          <template v-if="isLoading">
            <div class="modal-loading-container">
              <BaseLoading :isLoading="true" />
            </div>
          </template>

          <template v-else>
            <div class="modal-content">
              <!-- Expired Content -->
              <ShopeePayContent
                v-if="isExpired"
                :isExpired="true"
                :order-code="data?.orderCode"
                :total="data?.amount | currency2"
                :storeName="data?.storeName"
              />

              <!-- Active Content -->
              <ShopeePayContent
                v-else
                :qrCode="data?.qrCode"
                :order-code="data?.orderCode"
                :total="data?.amount | currency2"
                :storeName="data?.storeName"
                :timer="timer"
                :expiryDateTime="expiryDateTime"
              />
            </div>

            <div v-if="isExpired" class="modal-footer">
              <!-- Expired Content -->
              <Button
                depressed
                title="สั่งซื้ออีกครั้ง"
                @click="onClose, $emit('close')"
              />

              <!-- Active Content -->
              <!-- <Button
                v-else
                depressed
                title="ไปยังคำสั่งซื้อของคุณ"
                @click="handleGoToOrder"
              /> -->
            </div>
          </template>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ShopeePayContent from '@/components/payments/shopeePay/ShopeePayContent.vue'
import Button from '@/components/bnn/Button'
import BaseLoading from '@/components/base/BaseLoading.vue'
import { ORDER_STATUS } from '@/config/order'

export default {
  name: 'PaymentShopeePay',
  components: {
    Button,
    ShopeePayContent,
    BaseLoading,
  },

  props: {},

  data() {
    return {
      open: false,
      countDown: 0, // Countdown in seconds default 20 mins
      countDownInterval: null,
      isExpired: true,
    }
  },

  computed: {
    ...mapGetters({
      data: 'shopeePay/data',
      isLoading: 'shopeePay/isLoading',
      status: 'order/orderStatus',
    }),
    expiryDateTime() {
      return this.data?.expiryTime
        ? moment
            .unix(this.data.expiryTime)
            .format('DD/MM/YYYY, HH:mm:ss')
        : ''
    },
    timer() {
      let format = 'mm : ss'

      if (this.countDown > 3600) {
        format = 'HH : mm : ss'
      }
      return moment.utc(this.countDown * 1000).format(format)
    },
  },

  methods: {
    onOpen() {
      // Open delay to ensure the dialog is rendered
      setTimeout(() => {
        this.open = true
      }, 1500)

      if (this.data?.expiryTime) {
        this.countDown = moment
          .unix(this.data?.expiryTime)
          .diff(moment(), 'seconds')

        this.countDownTimer()
      }
    },
    onClose() {
      this.open = false
      this.resetShopeePay()
      this.resetCountdown()
    },
    resetShopeePay() {
      this.isExpired = true
      this.$store.dispatch('shopeePay/reset')
    },
    resetCountdown() {
      this.countDown = 0
      if (this.countDownInterval) {
        clearInterval(this.countDownInterval)
      }
      this.countDownInterval = null
      this.isExpired = true
    },
    handleGoToOrder() {
      this.$emit('go-to-order')
      this.onClose()
    },
    countDownTimer() {
      // Clear existing interval if any
      if (this.countDownInterval) {
        clearInterval(this.countDownInterval)
      }

      this.countDownInterval = setInterval(() => {
        this.countDown = moment
          .unix(this.data?.expiryTime)
          .diff(moment(), 'seconds')
        this.isExpired = false

        if (this.countDown <= 0) {
          clearInterval(this.countDownInterval)
          this.resetCountdown()
        }
      }, 1000)
    },
  },

  watch: {
    status(event) {
      if (event === ORDER_STATUS.COMPLETE) {
        this.handleGoToOrder()
      }
    },
  },

  mounted() {},

  beforeDestroy() {},

  unmounted() {
    this.resetShopeePay()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .shopee-pay-container {
  border-radius: 16px !important;
}

.modal-body-container {
  width: 100%;
  max-width: 420px;
  min-width: fit-content;
}

.modal-header {
  display: flex;
  justify-content: center;
  gap: 16px;

  width: 100%;
  padding: 4px 16px;
  background-color: #ee4d2d;

  .modal-header-title {
    font-size: 24px;
    font-weight: bold;
    align-self: center;
  }

  .modal-header-close {
    cursor: pointer;
    align-self: center;
  }
}

.modal-body {
  width: 100%;
  height: fit-content;

  transition: all 0.3s ease-in-out;

  .modal-loading-container {
    height: 420px;
  }

  .modal-content {
    padding: 24px;
  }

  .modal-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 24px 24px;
  }
}
</style>
